import { gray40opacity20 } from '../../../colors/gray';
import { red02 } from '../../../colors/red';
export var MuiLinearProgress = {
    styleOverrides: {
        colorPrimary: {
            backgroundColor: gray40opacity20,
        },
        colorSecondary: {
            backgroundColor: gray40opacity20,
        },
        barColorSecondary: {
            backgroundColor: red02,
        },
    },
};
